"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoginPreload = void 0;

var _react = require("react");

var _api = require("../api");

var _useRequest = require("./useRequest");

var _useProvisoApi = require("./useProvisoApi");

var useLoginPreload = function useLoginPreload(institution) {
  var api = (0, _useProvisoApi.useProvisoApi)();
  var state = (0, _useRequest.useRequest)();
  var request = state.request;
  (0, _react.useEffect)(function () {
    if (institution && api) {
      void request((0, _api.loginPreload)(api)(institution));
    }
  }, [institution, api, request]);
  return state;
};

exports.useLoginPreload = useLoginPreload;